/**
 * Request model for batch avatar optimization
 */
export interface BatchImageRequest {
    daiCds: string[];
    channelId: string;
}

/**
 * Progress event from SignalR
 */
export interface AvatarProcessingProgress {
    currentIndex: number;
    totalImages: number;
    percentage: number;
    currentDaiCd: string;
    message?: string;
    imageResult?: {
        daiCd: string;
        cdnUrl: string;
        status: 'success' | 'failed';
    };
}

/**
 * Individual image result
 */
export interface AvatarImageResult {
    daiCd: string;
    cdnUrl: string;
    originalSizeKB: number;
    webpSizeKB: number;
    savings: number;
    status: 'success' | 'failed' | 'skipped';
    error?: string;
}

/**
 * Complete batch result
 */
export interface AvatarBatchResult {
    channelId: string;
    totalProcessed: number;
    successCount: number;
    failedCount: number;
    skippedCount: number;
    results: AvatarImageResult[];
    totalSavingsKB: number;
    averageSavingsPercent: number;
}

/**
 * Error event from SignalR
 */
export interface AvatarProcessingError {
    message: string;
    daiCd?: string;
    error?: any;
}

/**
 * Processing status for tracking
 */
export enum ProcessingStatus {
    IDLE = 'idle',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

/**
 * Observable event types
 */
export interface AvatarOptimizationEvent {
    type: 'progress' | 'complete' | 'error';
    channelId: string;
    data: AvatarProcessingProgress | AvatarBatchResult | AvatarProcessingError;
}
